
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const BrowsePage = lazy(() => import('../pages/browse/page'));
const ReviewPage = lazy(() => import('../pages/review/page'));
const ModeratorPage = lazy(() => import('../pages/moderator/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/browse',
    element: <BrowsePage />
  },
  {
    path: '/review/:id',
    element: <ReviewPage />
  },
  {
    path: '/moderator',
    element: <ModeratorPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
